const getLocalStorage = (key) => {
  const item = localStorage.getItem(key);
  if (typeof item === "string") {
    return JSON.parse(item);
  } else {
    return null;
  }
}

export default getLocalStorage;